import { get, ENVIRONMENT } from "./base";

export function getPendoConfig() {
  return get(`pendo/${ENVIRONMENT}`);
}
